import {Component, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {UIService} from "@app/services/ui.service";
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/api";

@Component({
  selector: 'html-pop-up',
  templateUrl: './html-pop-up.component.html'
})
export class HtmlPopUpComponent implements OnInit, OnChanges{

  data: string = "";

  constructor(private ui: UIService,
              private refDialog: DynamicDialogRef,
              private configDialog: DynamicDialogConfig) {
  }


  ngOnInit() {
    this.data = this.configDialog.data;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.data = this.configDialog.data;
  }

}
